import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { CalenderPage } from 'src/app/pages/calender/calender.page';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { ToastService } from 'src/app/services/toast.service';
import { IClass } from 'src/app/shared/types/type.model';
import { format, formatISO, parseISO, } from 'date-fns';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-add-class',
  templateUrl: './add-class.page.html',
  styleUrls: ['./add-class.page.scss'],
})
export class AddClassPage implements OnInit {

  dataForm: FormGroup;
  showWarnings: boolean = false;
  unsubscribe = new Subject();
  uploadPercentage: string = '0';
  profileImageUrl;

  imageUrl: string = '';
  imageEvent: string = '';
  imagePreview = null;

  @Input('data') data;
  @Input('isEditing') isEditing;

  constructor(
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private firestoreService: FirestoreService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private apiService : ApiService,
    private alertService : AlertService,
    private route: ActivatedRoute,
    private location : Location
  ) {
    this.route.queryParams.subscribe(params => {
      console.log(params);
      
      if (params && params.data) {
        this.isEditing = true;
        const rowData = JSON.parse(params.data);
        console.log(rowData);
        this.data = rowData;
      }
    });
  }


  ngOnInit() {
    this.dataForm = this.formBuilder.group({
      name: new FormControl('', Validators.compose([Validators.required])),
      instructorName: new FormControl('', Validators.compose([Validators.required])),
      description: new FormControl('', Validators.compose([Validators.required])),
      schedules: this.formBuilder.array([
        this.formBuilder.group({
          day: ['', Validators.required],
          startTime: ['', Validators.required],
          endTime: ['', Validators.required],
          startFromDate: ['', Validators.required],
          endDate: ['', Validators.required],
        })
      ]),
    });
    
    console.log(this.data);

    if(this.data){
      this.dataForm.patchValue(this.data);
    }


    if (this.data && this.data.schedules && this.data.schedules.length > 0) {
      this.data = {...this.data}
      const schedulesFormArray = this.dataForm.get('schedules') as FormArray;
      schedulesFormArray.clear();
    
      for (const scheduleItem of this.data.schedules) {
        console.log(scheduleItem);      

        if (scheduleItem.startTime) {
          const seconds = scheduleItem.startTime.seconds || 0;
          const nanoseconds = scheduleItem.startTime.nanoseconds || 0;
          const milliseconds = seconds * 1000 + nanoseconds / 1e6;
          scheduleItem.startTime = new Date(milliseconds).toISOString();
          console.log(scheduleItem.startTime);
          // scheduleItem.startTime = scheduleItem.startTime?.toDate().toISOString();
          // console.log(scheduleItem.startTime);
        }
        if (scheduleItem.endTime) {
          
          const seconds = scheduleItem.endTime.seconds || 0;
          const nanoseconds = scheduleItem.endTime.nanoseconds || 0;
          const milliseconds = seconds * 1000 + nanoseconds / 1e6; 
          scheduleItem.endTime = new Date(milliseconds).toISOString();
          console.log(scheduleItem.endTime);
          // scheduleItem.endTime = scheduleItem.endTime?.toDate().toISOString();
          // console.log(scheduleItem.endTime);
        }
          const seconds = scheduleItem.startFromDate.seconds || 0;
          const nanoseconds = scheduleItem.startFromDate.nanoseconds || 0;
          const milliseconds = seconds * 1000 + nanoseconds / 1e6;
          scheduleItem.startFromDate = new Date(milliseconds);
          // scheduleItem.startFromDate = scheduleItem.startFromDate?.toDate();
          console.log(scheduleItem.startFromDate);

          const endDateSeconds = scheduleItem.endDate.seconds || 0;
          const endDateNanoseconds = scheduleItem.endDate.nanoseconds || 0;
          const endDateMilliseconds = endDateSeconds * 1000 + endDateNanoseconds / 1e6;
          scheduleItem.endDate = new Date(endDateMilliseconds);
          // scheduleItem.endDate = scheduleItem.endDate?.toDate();
          console.log(scheduleItem.endDate);

        

        const scheduleGroup = this.formBuilder.group({
          day: [scheduleItem.day, Validators.required],
          startTime: [scheduleItem.startTime, Validators.required],
          endTime: [scheduleItem.endTime, Validators.required],
          startFromDate: [scheduleItem.startFromDate, Validators.required],
          endDate: [scheduleItem.endDate, Validators.required],
        });
        schedulesFormArray.push(scheduleGroup);
        console.log(scheduleGroup);
        
      }
      console.log( "Data logged here", this.data);
      
      this.dataForm.patchValue(this.data);
    }

    this.dataForm.get('schedules').valueChanges.subscribe(res=>{
        console.log("newClassControls", this.newClassControls);
        
        if(this.newClassControls.controls.length == 0){
          console.log("adding here");
          this.addSchedule();
        }
    })

    console.log("ONE", this.dataForm.get('schedules') as FormArray);
    console.log("TWO", this.dataForm.get('schedules').value);
    
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  async addData() {
    this.showWarnings = true;    

    console.log(this.dataForm.value);
    
    if (this.dataForm.valid) {
      this.loadingCtrl
        .create({ keyboardClose: true, cssClass: 'loading-ctrl' })
        .then(async (loadingEl) => {
          loadingEl.present();

          if (this.dataForm.value && this.dataForm.value.schedules && this.dataForm.value.schedules.length > 0) {
            const schedulesArray = this.dataForm.get('schedules').value;
          for (let i = 0; i < schedulesArray.length; i++) {
            const scheduleGroup = schedulesArray[i];

            let startFrom = scheduleGroup.startFromDate;
            let endDate = scheduleGroup.endDate;
           if( moment(startFrom).isAfter(moment(endDate))){
            this.toastService.presentToast("Start from date cannot be later than to date");
            loadingEl.dismiss();
            return;
           }
          }
        }




          let data: IClass = {
            ...this.dataForm.value,
          };
          //change date values 
          if (this.dataForm.value && this.dataForm.value.schedules && this.dataForm.value.schedules.length > 0) {
            const schedulesArray = this.dataForm.get('schedules').value;
          
            for (let i = 0; i < schedulesArray.length; i++) {
              const scheduleGroup = schedulesArray[i];

              let startFrom = scheduleGroup.startFromDate;
              let endDate = scheduleGroup.endDate;
             if( moment(startFrom).isAfter(moment(endDate))){
              this.toastService.presentToast("Start from date cannot be later than to date");
              loadingEl.dismiss();
              return;
             }
          
              let scheduleStartTime = scheduleGroup.startTime;
              let scheduleEndTime = scheduleGroup.endTime;
          
              if (scheduleStartTime) {
                const parsedStartTime = parseISO(scheduleStartTime);
                console.log(`Start Time for Schedule ${i + 1}:`, parsedStartTime);
                data.schedules[i].startTime = parsedStartTime;
              }
          
              if (scheduleEndTime) {
                const parsedEndTime = parseISO(scheduleEndTime);
                console.log(`End Time for Schedule ${i + 1}:`, parsedEndTime);
                data.schedules[i].endTime = parsedEndTime;


              }
            }
          }





          if (this.isEditing) {
             data.updatedDate = new Date();

            // if(data.startTime){
            //   data.startTime = parseISO(this.dataForm.value.startTime)
            // }
            // if(data.endTime){
            //   data.endTime = parseISO(this.dataForm.value.endTime)
            // }
            this.firestoreService
              .updateDocument(this.firestoreService.CLASSES, this.data.id, data)
              .subscribe((res) => {
                loadingEl.dismiss();
                this.toastService.presentToast('Class updated');
                this.location.back();
             });
          } else {
             data.addedDate = new Date()
            console.log(data);
            console.log(this.dataForm.value);

            
            
            // if (this.dataForm.value && this.dataForm.value.schedules && this.dataForm.value.schedules.length > 0) {
            //   const schedulesArray = this.dataForm.get('schedules') as FormArray;
            
            //   for (let i = 0; i < schedulesArray.length; i++) {
            //     const scheduleGroup = schedulesArray.at(i) as FormGroup;
            
            //     const scheduleStartTime = scheduleGroup.get('startTime').value;
            //     const scheduleEndTime = scheduleGroup.get('endTime').value;
            
            //     if (scheduleStartTime) {
            //       const parsedStartTime = parseISO(scheduleStartTime);
            //       console.log(`Start Time for Schedule ${i + 1}:`, parsedStartTime);
            //       data.schedules[i].startTime = parsedStartTime;
            //     }
            
            //     if (scheduleEndTime) {
            //       const parsedEndTime = parseISO(scheduleEndTime);
            //       console.log(`End Time for Schedule ${i + 1}:`, parsedEndTime);
            //       data.schedules[i].endTime = parsedEndTime;


            //     }
            //   }
            // }
            
            console.log("adding data", data);
            
            this.firestoreService.addToCollection(this.firestoreService.CLASSES, data).subscribe(res=>{
              loadingEl.dismiss();

                  this.toastService.presentToast('Class added');
                  this.location.back();
            },(err=>{
              loadingEl.dismiss();
              console.log("Error", err);
              this.alertService.showFirebaseAlert(err);
            }))
          }
        });
    } else {
      this.toastService.presentToast(
        'All the fields should be filled and valid'
      );
    }
  }

  activeAditionalBackdrop = false;
  async changeDate(type: number, event: Event) {
    if(this.isEditing) return;
   if (!this.activeAditionalBackdrop) {
     console.log('Clicked once');

     const modal = await this.modalCtrl.create({
       component: CalenderPage,
       componentProps: {
         type: 'time',
       },
       cssClass: 'calender-modal',
       // mode: 'md',
       backdropDismiss: true,
       showBackdrop: true,
     });
     modal.onDidDismiss().then((data) => {
       this.activeAditionalBackdrop = false;
       if (data.data) {
         if (type == 1) this.dataForm.get('time')?.patchValue(data.data);
       }
     });
     this.activeAditionalBackdrop = true;
     event.preventDefault();
     event.stopPropagation();
     await modal.present();
   }
 }

 get newClassControls() {
  return this.dataForm.get('schedules') as FormArray;
}

 sheduleFormGroupByIndex(index: number, controlName){
  return (this.newClassControls.controls[index] as FormGroup).get(controlName);
}
addSchedule(){
  console.log("clicked addSchedule");
  const newSchedule = this.formBuilder.group({
    day: ['', Validators.required],
    startTime: ['', Validators.required],
    endTime: ['', Validators.required],
    startFromDate: ['', Validators.required],
    endDate: ['', Validators.required],
  });

  this.newClassControls.push(newSchedule);
}

deleteSchedule(i){
  console.log(i);
  
  const options = this.newClassControls;
  if (options.length > 1) {
    options.removeAt(i);
  } else {
    options.reset();
  }
}

removeClass(){
  this.newClassControls.clear()
}

}
